import { ReactNode } from "react";

import { CloseButton, Drawer, Flex } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { DRAWER_HEADER_HEIGHT } from "../constants/ui";

interface FlagDrawerHeaderProps {
  title: string;
  onClose: () => void;
  /** The header's commit controls, on the right. */
  children?: ReactNode;
  closeLabel?: string;
  closeTestId?: string;
  closeDisabled?: boolean;
}

/**
 * The header every flag drawer shares, in the shape most drawers in the app use: close (X), then
 * the title, then the drawer's commit controls on the right — so it reads left to right as
 * dismiss, subject, commit.
 */
export default function FlagDrawerHeader({
  title,
  onClose,
  children,
  closeLabel = "Close",
  closeTestId,
  closeDisabled = false,
}: FlagDrawerHeaderProps) {
  return (
    <Drawer.Header px="md" bg="gray.0" h={DRAWER_HEADER_HEIGHT}>
      <Flex w="100%" gap="md" align="center" justify="space-between">
        <Flex gap="md" align="center" style={{ flex: 1 }}>
          <CloseButton
            onClick={onClose}
            aria-label={closeLabel}
            disabled={closeDisabled}
            data-testid={closeTestId}
          />
          <Drawer.Title style={{ flex: 1 }}>
            <TextWrapper fz="lg" variant="bold">
              {title}
            </TextWrapper>
          </Drawer.Title>
        </Flex>
        {children}
      </Flex>
    </Drawer.Header>
  );
}
